<style>
.sitecore-experience-editor .hero {
    height: auto !important;
}
.sitecore-experience-editor .hero .swiper-container {
    height: auto !important;
}
.sitecore-experience-editor .hero .swiper-container .swiper-wrapper {
    display: block !important;
}
.sitecore-experience-editor .hero .swiper-container .swiper-wrapper .swiper-slide {
    min-height: 500px !important;
    height: auto !important;
    display: block !important;
}
.sitecore-experience-editor .hero .swiper-container .hero-swiper-button-prev,
.sitecore-experience-editor .hero .swiper-container .hero-swiper-button-next {
    display: none !important;
}
.hero {
    padding: 0;
    height: 500px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
}
@media (min-width: 992px) {
    .hero.hero-small {
        height: 350px;
    }
}
.hero .swiper-container {
    position: relative;
    width: 100%;
    height: 100%;
    overflow: hidden;
}
.hero .swiper-container .swiper-wrapper {
    display: -webkit-inline-box;
    display: -ms-inline-flexbox;
    display: inline-flex;
    height: 100%;
}
@media (max-width: 992px) {
    .hero .swiper-container .swiper-wrapper {
        height: 50%;
    }
}
.hero .swiper-container .swiper-wrapper .swiper-slide {
    background-size: cover;
    background-position: center center;
    background-repeat: no-repeat;
    text-align: center;
    font-size: 18px;
    background-color: white;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    height: 100%;
    padding: 40px 15px;
    position: relative;
    width: 100%;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
}
.hero .swiper-container .swiper-wrapper .swiper-slide .hero-details {
    position: absolute;
    bottom: 60px;
    left: 50%;
    -webkit-transform: translateX(-50%);
    -ms-transform: translateX(-50%);
    transform: translateX(-50%);
}
@media (max-width: 992px) {
    .hero .swiper-container .swiper-wrapper .swiper-slide .hero-details {
        height: 100%;
        width: 100%;
        top: 100%;
        padding: 25px;
    }
}
@media (max-width: 992px) {
    .hero .swiper-container .swiper-wrapper .swiper-slide .hero-details.dark-img-theme {
        background-color: #002d53;
    }
}
.hero .swiper-container .swiper-wrapper .swiper-slide .hero-details.dark-img-theme .hero-subtitle {
    color: #84bee0;
}
.hero .swiper-container .swiper-wrapper .swiper-slide .hero-details.dark-img-theme .hero-title {
    color: white;
}
.hero .swiper-container .swiper-wrapper .swiper-slide .hero-details.dark-img-theme .hero-caption {
    color: white;
}
@media (max-width: 992px) {
    .hero .swiper-container .swiper-wrapper .swiper-slide .hero-details.light-img-theme {
        background-color: white;
    }
}
.hero .swiper-container .swiper-wrapper .swiper-slide .hero-details.light-img-theme .hero-subtitle {
    color: #d34400;
}
.hero .swiper-container .swiper-wrapper .swiper-slide .hero-details.light-img-theme .hero-title {
    color: #002d53;
}
.hero .swiper-container .swiper-wrapper .swiper-slide .hero-details.light-img-theme .hero-caption {
    color: #002d53;
}
.hero .swiper-container .swiper-wrapper .swiper-slide .hero-details .hero-subtitle {
    font-size: 2.2rem;
    color: #84bee0;
    margin: 0;
}
@media (min-width: 992px) {
    .hero .swiper-container .swiper-wrapper .swiper-slide .hero-details .hero-subtitle {
        margin-bottom: -8px;
    }
}
@media (max-width: 992px) {
    .hero .swiper-container .swiper-wrapper .swiper-slide .hero-details .hero-subtitle {
        font-size: 1.7rem;
    }
}
.hero .swiper-container .swiper-wrapper .swiper-slide .hero-details .hero-title {
    color: white;
    font-size: 4rem;
    margin-bottom: 5px;
}
@media (max-width: 992px) {
    .hero .swiper-container .swiper-wrapper .swiper-slide .hero-details .hero-title {
        font-size: 2.5rem;
    }
}
.hero .swiper-container .swiper-wrapper .swiper-slide .hero-details .hero-caption {
    font-family: "Open Sans", sans-serif;
    font-weight: 400;
    font-size: 1.5rem;
    color: white;
}
@media (max-width: 992px) {
    .hero .swiper-container .swiper-wrapper .swiper-slide .hero-details .hero-caption {
        font-size: 1rem;
    }
}
.hero .swiper-container .swiper-notification {
    opacity: 0;
}
.hero .swiper-container .hero-swiper-button-prev,
.hero .swiper-container .hero-swiper-button-next {
    position: absolute;
    z-index: 2;
    top: 50%;
    -webkit-transform: translateY(-50%);
    -ms-transform: translateY(-50%);
    transform: translateY(-50%);
    cursor: pointer;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    background-image: none;
    padding: 100% 50px;
    -webkit-transition: all 0.3s;
    transition: all 0.3s;
    background: transparent;
}
@media (max-width: 992px) {
    .hero .swiper-container .hero-swiper-button-prev,
    .hero .swiper-container .hero-swiper-button-next {
        padding: 40% 50px 95% 0px;
        outline: 0;
        border: 0;
    }
    .hero .swiper-container .hero-swiper-button-prev svg,
    .hero .swiper-container .hero-swiper-button-next svg {
        height: 1.3em;
    }
}
@media (min-width: 768px) and (max-width: 991px) {
    .hero .swiper-container .hero-swiper-button-prev,
    .hero .swiper-container .hero-swiper-button-next {
        padding: 25% 50px 50% 0px;
    }
}
@media (min-width: 992px) {
    .hero .swiper-container .hero-swiper-button-prev:hover:before,
    .hero .swiper-container .hero-swiper-button-next:hover:before {
        opacity: 1;
        -webkit-transition: opacity 250ms ease;
        transition: opacity 250ms ease;
    }
}
.hero .swiper-container .hero-swiper-button-prev:before,
.hero .swiper-container .hero-swiper-button-next:before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    opacity: 0;
}
@media (min-width: 992px) {
    .hero .swiper-container .hero-swiper-button-prev:before,
    .hero .swiper-container .hero-swiper-button-next:before {
        -webkit-transition: opacity 500ms ease;
        transition: opacity 500ms ease;
    }
}
.hero .swiper-container .hero-swiper-button-prev svg,
.hero .swiper-container .hero-swiper-button-next svg {
    position: absolute;
    -webkit-transform-origin: center center;
    -ms-transform-origin: center center;
    transform-origin: center center;
    height: 2em;
    fill: white;
    -webkit-filter: drop-shadow(1px 1px 8px rgba(0, 0, 0, 0.9));
    filter: drop-shadow(1px 1px 8px rgba(0, 0, 0, 0.9));
}
.hero .swiper-container .hero-swiper-button-prev {
    left: 0;
}
@media (min-width: 992px) {
    .hero .swiper-container .hero-swiper-button-prev:before {
        background: rgba(0, 0, 0, 0);
        background: -webkit-gradient(linear, right top, left top, from(rgba(0, 0, 0, 0)), to(rgba(0, 0, 0, 0.25)));
        background: linear-gradient(-90deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.25) 100%);
    }
}
.hero .swiper-container .hero-swiper-button-prev svg {
    left: 50%;
    -webkit-transform: rotate(180deg) translateX(50%);
    -ms-transform: rotate(180deg) translateX(50%);
    transform: rotate(180deg) translateX(50%);
}
.hero .swiper-container .hero-swiper-button-next {
    right: 0;
}
@media (min-width: 992px) {
    .hero .swiper-container .hero-swiper-button-next:before {
        background: rgba(0, 0, 0, 0.25);
        background: -webkit-gradient(linear, right top, left top, from(rgba(0, 0, 0, 0.25)), to(rgba(0, 0, 0, 0)));
        background: linear-gradient(-90deg, rgba(0, 0, 0, 0.25) 0%, rgba(0, 0, 0, 0) 100%);
    }
    .hero .swiper-container .hero-swiper-button-next:hover:before {
        opacity: 1;
    }
}
.hero .swiper-container .hero-swiper-button-next svg {
    right: 50%;
    -webkit-transform: translateX(50%);
    -ms-transform: translateX(50%);
    transform: translateX(50%);
}
.hero.single .swiper-container .swiper-wrapper {
    display: block;
}
.hero.single .swiper-container .hero-swiper-button-prev,
.hero.single .swiper-container .hero-swiper-button-next {
    display: none;
}
</style>


<template>

	<div>
		<Header :utilityNav="header.utilityNav" :siteNavigation="header.siteNavigation"></Header>
		<Hero :slides="hero.slides" :smallHero="hero.smallHero"></Hero>
		<Search :placeholderText="search.placeholderText" :icon="search.icon"></Search>
		<ServicesGrid :subtitle="servicesGrid.subtitle" :title="servicesGrid.title" :services="servicesGrid.services" :cta="servicesGrid.cta"></ServicesGrid>
		<News :subtitle="news.subtitle" :title="news.title" :fullWidthNewsItems="news.fullWidthNewsItems" :halfWidthNewsItems="news.halfWidthNewsItems" :miniNewsItems="news.miniNewsItems" :cta="news.cta"></News>
		<UpcomingEvents :subtitle="upcomingEvents.subtitle" :title="upcomingEvents.title" :featuredEvents="upcomingEvents.featuredEvents" :miniEvents="upcomingEvents.miniEvents" :cta="upcomingEvents.cta"></UpcomingEvents>
		<Bios :subtitle="bios.subtitle" :title="bios.title" :bioSection="bios.bioSection" :cta="bios.cta"></Bios>
		<DistrictLocator :title="districtLocator.title" :body="districtLocator.body" :form="districtLocator.form" :summary="districtLocator.summary" :image="districtLocator.image"></DistrictLocator>
		<SocialCarousel :subtitle="socialCarousel.subtitle" :title="socialCarousel.title" :socialItems="socialCarousel.socialItems"></SocialCarousel>
		<NewsletterSignup  :subtitle="newsletterSignup.subtitle" :title="newsletterSignup.title" :body="newsletterSignup.body" :submit="newsletterSignup.submit" :forms="newsletterSignup.forms"></NewsletterSignup>
		<Footer :contact="footer.contact" :nav="footer.nav" :social="footer.social" :legal="footer.legal"></Footer>
	</div>
	
</template>

<script>
	
	import Header from '../components/Header/Header.vue';
	import Hero from '../components/Hero/Hero.vue';
	import Search from '../components/Search/Search.vue';
	import ServicesGrid from '../components/ServicesGrid/ServicesGrid.vue';
	import News from '../components/News/News.vue';
	import UpcomingEvents from '../components/Events/UpcomingEvents.vue';
	import Bios from '../components/Bios/Bios.vue';
	import DistrictLocator from '../components/DistrictLocator/DistrictLocator.vue';
	import SocialCarousel from '../components/Social/SocialCarousel.vue';
	import NewsletterSignup from '../components/News/NewsletterSignup.vue';
	import Footer from '../components/Footer/Footer.vue';
	import axios from 'axios';
	
	export default {
		name: 'Homepage',
		
		components: {
			Header,
			Hero,
			Search,
			ServicesGrid,
			News,
			UpcomingEvents,
			Bios,
			DistrictLocator,
			SocialCarousel,
			NewsletterSignup,
			Footer
		},
		
		data() {
			return {
				header: {
					utilityNav: {},
					siteNavigation: {}
				},
				hero: {
					slides: [],
					smallHero: {}
				},
				search: {
					placeholderText: "",
					icon: ""
				},
				servicesGrid: {
					subtitle: "",
					title: "",
					services: [],
					cta: ""
				},
				news: {
					subtitle: "",
					title: "",
					fullWidthNewsItems: [],
					halfWidthNewsItems: [],
					miniNewsItems: [],
					cta: {}
				},
				upcomingEvents: {
					subtitle: "",
					title: "",
					featuredEvents: [],
					miniEvents: [],
					cta: {}
				},
				bios: {
					subtitle: "",
					title: "",
					bioSection: [],
					cta: {}
				},
				districtLocator: {
					title: "",
					body: "",
					form: {},
					summary: {},
					image: ""
				},
				socialCarousel: {
					subtitle: "",
					title: "",
					socialItems: []
				},
				newsletterSignup: {
					subtitle: "",
					title: "",
					body: "",
					submit: "",
					forms: []
				},
				footer: {
					contact: {},
					nav: [],
					social: [],
					legal: ""
				}
			}
		},
		
		mounted: function() {
			
			/* eslint-disable no-console */
			let self = this;
			
			let header = 'SampleData/HeaderData.json';
			axios.get(header).then(function(response) {
				
				self.header.utilityNav = response.data.utilityNav;
				self.header.siteNavigation = response.data.siteNavigation;
			})
			.catch(function (error) {
				console.log(error);
			});
			
			let hero = 'SampleData/HeroData.json';
			axios.get(hero).then(function(response) {
				
				self.hero.slides = response.data.slides;
				self.hero.smallHero = response.data.smallHero;
			})
			.catch(function (error) {
				console.log(error);
			});
			
			let search = 'SampleData/SearchData.json';
			axios.get(search).then(function(response) {
				
				self.search.placeholderText = response.data.placeholderText;
				self.search.icon = response.data.icon;
			})
			.catch(function (error) {
				console.log(error);
			});
			
			let servicesGrid = 'SampleData/ServicesGridData.json';
			axios.get(servicesGrid).then(function(response) {
				
				self.servicesGrid.subtitle = response.data.subtitle;
				self.servicesGrid.title = response.data.title;
				self.servicesGrid.services = response.data.services;
				self.servicesGrid.cta = response.data.cta;
			})
			.catch(function (error) {
				console.log(error);
			});
			
			let news = 'SampleData/NewsData.json';
			axios.get(news).then(function(response) {
				
				self.news.subtitle = response.data.subtitle;
				self.news.title = response.data.title;
				self.news.fullWidthNewsItems = response.data.fullWidthNewsItems;
				self.news.halfWidthNewsItems = response.data.halfWidthNewsItems;
				self.news.miniNewsItems = response.data.miniNewsItems;
				self.news.cta = response.data.cta;
			})
			.catch(function (error) {
				console.log(error);
			});
			
			let upcomingEvents = 'SampleData/UpcomingEventsData.json';
			axios.get(upcomingEvents).then(function(response) {
				
				self.upcomingEvents.subtitle = response.data.subtitle;
				self.upcomingEvents.title = response.data.title;
				self.upcomingEvents.featuredEvents = response.data.featuredEvents;
				self.upcomingEvents.miniEvents = response.data.miniEvents;
				self.upcomingEvents.cta = response.data.cta;
			})
			.catch(function (error) {
				console.log(error);
			});
			
			let bios = 'SampleData/BiosData.json';
			axios.get(bios).then(function(response) {
				
				self.bios.subtitle = response.data.subtitle;
				self.bios.title = response.data.title;
				self.bios.bioSection = response.data.bioSection;
				self.bios.cta = response.data.cta;
			})
			.catch(function (error) {
				console.log(error);
			});
			
			let districtLocator = 'SampleData/DistrictLocatorData.json';
			axios.get(districtLocator).then(function(response) {
				
				self.districtLocator.title = response.data.title;
				self.districtLocator.body = response.data.body;
				self.districtLocator.form = response.data.form;
				self.districtLocator.summary = response.data.summary;
				self.districtLocator.image = response.data.image;
			})
			.catch(function (error) {
				console.log(error);
			});
			
			let socialCarousel = 'SampleData/SocialCarouselData.json';
			axios.get(socialCarousel).then(function(response) {
				
				self.socialCarousel.title = response.data.title;
				self.socialCarousel.subtitle = response.data.subtitle;
				self.socialCarousel.socialItems = response.data.socialItems;
			})
			.catch(function (error) {
				console.log(error);
			});
			
			let newsletterSignup = 'SampleData/NewsletterSignupData.json';
			axios.get(newsletterSignup).then(function(response) {
				
				self.newsletterSignup.title = response.data.title;
				self.newsletterSignup.subtitle = response.data.subtitle;
				self.newsletterSignup.title = response.data.title;
				self.newsletterSignup.body = response.data.body;
				self.newsletterSignup.submit = response.data.submit;
				self.newsletterSignup.forms = response.data.forms;
			})
			.catch(function (error) {
				console.log(error);
			});
			
			let footer = 'SampleData/FooterData.json';
			axios.get(footer).then(function(response) {
				
				self.footer.contact = response.data.contact;
				self.footer.nav = response.data.nav;
				self.footer.social = response.data.social;
				self.footer.legal = response.data.legal;
			})
			.catch(function (error) {
				console.log(error);
			});
		}
	}
	
</script>